import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from 'js-cookie'

export const getDetails = createApi({
  reducerPath: "getDetails",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token || Cookies.get("TheShow_Admin_Token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getDetails: builder.query({
      query: (token) => ({
        url: "admin/profile",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    editProfile: builder.mutation({
      query: (body) => ({
        url: "admin/update-profile",
        method: "POST",
        body,
      })
    }),
    changePassword: builder.mutation({
      query: (body) => ({
        url: "admin/change-password",
        method: "POST",
        body,
        mutation: ["PASSWORD"]
      })
    })
  }),
});

export const { useGetDetailsQuery, useEditProfileMutation, useChangePasswordMutation } = getDetails;
